<template>
  <span :class="computedClass">
    {{ $t(`models.user.statuses.${value}`) }}
  </span>
</template>
<script>
export default {
  props: ['item', 'column', 'model'],
  computed: {
    computedClass(){
      let classes = ["sensual-badge"]
      if (this.value == 'active' || this.value == 'confirmed') {
        classes.push('green')
      } else if (this.value == 'review') {
        classes.push('yellow')
      } else if (this.value == 'pre_review') {
        classes.push('red')
      } else if (this.value == 'inactive' || this.value == 'unconfirmed') {
        classes.push('grey')
      } else if (this.value == 'pending') {
        classes.push('blue')
      }
      return classes
    },
    value(){
      return eval('this.item.' + this.column.name)
    }
  }
}
</script>
<style lang="scss" scoped>
.status-confirmed,
.status-active{
  color: $form-valid-color;
}
.status-review{
  color: $lead-warm;
}
.status-unconfirmed,
.status-inactive{
  color: $lead-hot;
}


</style>



// WEBPACK FOOTER //
// CollectionValueStatus.vue?5fd17d80